import config from "@/config";
import http from "@/utils/request";

export default {
	store: {
		//门店列表（GET，buildTableParames筛选，返回{total,list}）
		index: {
			url: `${config.API_URL}/bwmall/admin/store/index`,
			name: "门店列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//门店新增（POST：name/desc/logo/mobile/province_name/province_id/city_name/city_id/region_name/region_id/address/lon/lat/business_time/status全必填）
		add: {
			url: `${config.API_URL}/bwmall/admin/store/add`,
			name: "门店新增",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//门店详情（GET ?id=，返回{row}，row含province/city/county文本）
		editGet: {
			url: `${config.API_URL}/bwmall/admin/store/edit`,
			name: "门店详情",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//门店编辑保存（POST，同add字段）
		editPost: {
			url: `${config.API_URL}/bwmall/admin/store/edit`,
			name: "门店编辑",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//属性修改（POST：id/field/value，field支持status）
		modify: {
			url: `${config.API_URL}/bwmall/admin/store/modify`,
			name: "门店属性修改",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//删除/批量删除（POST：ids）
		del: {
			url: `${config.API_URL}/bwmall/admin/store/del`,
			name: "门店删除",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//高德地图Key（GET，门店地图选点用，配置项 store_config.amap_key）
		mapKey: {
			url: `${config.API_URL}/bwmall/admin/store/mapKey`,
			name: "高德地图Key",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		}
	},
	storeStaff: {
		//核销员列表（GET，支持?store_id=过滤，行含bwmallStore.name/user.nickname）
		index: {
			url: `${config.API_URL}/bwmall/admin/store/staff/index`,
			name: "核销员列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//新增-取下拉（GET，返回{getBwmallStoreList,getUserList}）
		addGet: {
			url: `${config.API_URL}/bwmall/admin/store/staff/add`,
			name: "核销员新增下拉",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//新增保存（POST：user_id/store_id/name/mobile/status）
		addPost: {
			url: `${config.API_URL}/bwmall/admin/store/staff/add`,
			name: "核销员新增",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//编辑-取详情（GET ?id=，返回{row,getBwmallStoreList,getUserList}）
		editGet: {
			url: `${config.API_URL}/bwmall/admin/store/staff/edit`,
			name: "核销员详情",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		},
		//编辑保存（POST，同add字段）
		editPost: {
			url: `${config.API_URL}/bwmall/admin/store/staff/edit`,
			name: "核销员编辑",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//属性修改（POST：id/field/value，field支持status）
		modify: {
			url: `${config.API_URL}/bwmall/admin/store/staff/modify`,
			name: "核销员属性修改",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		},
		//删除/批量删除（POST：ids）
		del: {
			url: `${config.API_URL}/bwmall/admin/store/staff/del`,
			name: "核销员删除",
			post: async function(data={}){
				return await http.post(this.url, data);
			}
		}
	},
	storeOrder: {
		//核销订单列表（GET，status>1且shipping_type=2，行含_info/user，返回extend{order_num,price_sum,today_order_num,today_price_sum}统计；后端无增删改）
		index: {
			url: `${config.API_URL}/bwmall/admin/store/order/index`,
			name: "核销订单列表",
			get: async function(data={}){
				return await http.get(this.url, data);
			}
		}
	}
}
